// extracted by mini-css-extract-plugin
module.exports = {"error-container":"error-container--Cfubd","icon":"icon--2J-Uh","btn":"btn--1XVo_"};